import { useState } from "react";
import classes from "./Banner.module.scss";
import Button from "../../../Components/Button/Button";
import { ReactComponent as PlayCirlce } from "../../../assets/icons/playCircle.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/circleClose.svg";
import ClemBanner from "../../../assets/images/clemBanner.png";

const Banner = () => {
  const [videoVisible, setVideoVisible] = useState(false);

  const watchOverviewClickHandler = () => {
    setVideoVisible(true);
  };

  const blackScreenClickHandler = () => {
    setVideoVisible(false);
  };

  return (
    <div className={classes["homepage-container"]}>
      <div className={classes["home-page-image-text-container"]}>
        <div className={classes["home-page-image-container"]}>
          <img src={ClemBanner} alt="CLEM" width={"100%"} height={"100%"} />
        </div>

        <div className={classes["white-image-layer"]}></div>

        <div className={classes["home-page-content"]}>
          <p className={classes["home-page-content-heading"]}>
            <div className={classes["making-text"]}>Making</div>
            <div className={classes["nt-text"]}>Net-Zero Transitions</div>
            <div className={classes["profitable-text"]}>Profitable</div>
          </p>

          <p className={classes["home-page-content-desc"]}>
            Begin your journey with us as we help you turn clean energy
            transitions into sustainable, investment-ready opportunities
          </p>

          <Button
            text={
              <>
                Watch Overview <PlayCirlce />
              </>
            }
            btnClickHandler={watchOverviewClickHandler}
            className={classes["watch-overview-btn"]}
          />
        </div>
      </div>

      {videoVisible && (
        <div
          className={classes["black-screen"]}
          onClick={blackScreenClickHandler}
        >
          <div
            className={classes["video-container"]}
            onClick={(e) => e.stopPropagation()}
          >
            <video
              src={
                "https://se-website-image.s3.ap-south-1.amazonaws.com/clem/clem-overview.mp4"
              }
              controls={true}
              width="100%"
              height="100%"
              autoPlay
              title="CLEM Overview"
            ></video>

            <div
              className={classes["close-icon-container"]}
              onClick={blackScreenClickHandler}
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;
